// eslint-disable-next-line import/no-extraneous-dependencies
import $ from 'jquery';
import Swiper from 'swiper/bundle';
import { swiperOptions } from './module/SwiperFunctions';

document.addEventListener('DOMContentLoaded', () => {
  // spot/:idのmv
  if (document.querySelector('[data-role="show-article-swiper"]')) {
    new Swiper(
      '[data-role="show-article-swiper"]',
      swiperOptions({
        slidesPerView: 1,
        spaceBetween: 16,
        centeredSlides: true,
        navigation: {
          nextEl: '.showArticle__mainViewSwiper .u-articleSwiperButton--next',
          prevEl: '.showArticle__mainViewSwiper .u-articleSwiperButton--prev',
        },
        breakpoints: {
          768: {
            slidesPerView: 1.7,
          },
        },
        pagination: {
          el: '.showArticle__mainViewPagination',
          bulletClass: 'showArticle__swiperPaginationBullet',
          bulletActiveClass: 'showArticle__swiperPaginationBullet--active',
          clickable: true,
        },
      })
    );
  }

  // spot/:idの関連記事のswiper
  // 共通のswiperオプション
  const connectionSpotSwiperOptions = {
    spaceBetween: 20,
    slidesPerView: 'auto',
    breakpoints: {
      768: {
        spaceBetween: 32,
      },
    },
  };

  // 近くの観光スポット
  if (document.querySelector('.showArticle__connectionSpotSwiper--tourism')) {
    new Swiper(
      '.showArticle__connectionSpotSwiper--tourism',
      swiperOptions({
        navigation: {
          nextEl: '.showArticle__connectionSpotSwiperButtonNext--tourism',
          prevEl: '.showArticle__connectionSpotSwiperButtonPrev--tourism',
        },
        ...connectionSpotSwiperOptions,
      })
    );
  }

  // 近くのグルメスポット
  if (document.querySelector('.showArticle__connectionSpotSwiper--gourmet')) {
    new Swiper(
      '.showArticle__connectionSpotSwiper--gourmet',
      swiperOptions({
        navigation: {
          nextEl: '.showArticle__connectionSpotSwiperButtonNext--gourmet',
          prevEl: '.showArticle__connectionSpotSwiperButtonPrev--gourmet',
        },
        ...connectionSpotSwiperOptions,
      })
    );
  }

  // 近くの宿泊施設
  if (document.querySelector('.showArticle__connectionSpotSwiper--hotel')) {
    new Swiper(
      '.showArticle__connectionSpotSwiper--hotel',
      swiperOptions({
        navigation: {
          nextEl: '.showArticle__connectionSpotSwiperButtonNext--hotel',
          prevEl: '.showArticle__connectionSpotSwiperButtonPrev--hotel',
        },
        ...connectionSpotSwiperOptions,
      })
    );
  }

  if (document.querySelector('#one_page_print')) {
    document.querySelector('#one_page_print').addEventListener(
      'click',
      () => {
        document.querySelector('#spot_image_print').style.display = 'none';
        document.querySelector('#spot_images').style.display = '';
        document.querySelectorAll('[name="spot_image_data"]').forEach((el) => {
          el.style.breakAfter = 'page';
        });
      },
      { once: true }
    );

    document.querySelector('#multi_page_print').addEventListener(
      'click',
      () => {
        document.querySelector('#spot_image_print').style.display = 'none';
        document.querySelector('#spot_images').style.display = '';
        document.querySelectorAll('[name="spot_image_data"]').forEach((el) => {
          el.style.breakInside = 'avoid-page';
        });
      },
      { once: true }
    );
  }
});

$(() => {
  // 現在地取得成功時のみサーバに処理を送信する
  function successGetPosition(position) {
    const url = $('#sort_distance').attr('href');
    $('#sort_distance').attr('href', `${url}&lat=${position.coords.latitude}&lng=${position.coords.longitude}`);
    window.location.href = `${url}&lat=${position.coords.latitude}&lng=${position.coords.longitude}`;
  }

  function failGetPosition(error) {
    // eslint-disable-next-line default-case
    switch (error.code) {
      case error.PERMISSION_DENIED:
        // eslint-disable-next-line no-alert
        alert('位置情報の取得が許可されませんでした');
        break;
      case error.POSITION_UNAVAILABLE:
        // eslint-disable-next-line no-alert
        alert('電波状況などで位置情報が取得できませんでした');
        break;
      case error.TIMEOUT:
        // eslint-disable-next-line no-alert
        alert('位置情報の取得にてタイムアウトが発生しました');
        break;
      case error.UNKNOWN_ERROR:
        // eslint-disable-next-line no-alert
        alert('原因不明のエラーが発生しました');
        break;
    }
  }

  // 現在地に近いボタン押下時、現在地を取得する
  if ($('#sort_distance').length) {
    $('#sort_distance').click(() => {
      const options = {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0,
      };

      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(successGetPosition, failGetPosition, options);
      } else {
        // eslint-disable-next-line no-alert
        alert('ご使用中のブラウザは現在地検索に対応されておりません');
      }
      return false;
    });
  }

  if ($('#spot_search').length) {
    $('input[name="parent_category_ids[]"]').click((e) => {
      const parentElement = e.target.closest('div');
      parentElement.querySelectorAll('input[name="q[categories_id_in][]"]').forEach((el) => {
        el.checked = e.target.checked;
      });
    });

    // タグ選択の場合、親の選択状態を設定/解除を行う
    $('input[name="q[categories_id_in][]"]').click((e) => {
      const categoryId = e.target.dataset.categoryId;
      document.getElementById(`parent_category_id_${categoryId}`).checked = false;
    });

    $('input[name="category_ids[]"]').click((e) => {
      const parentElement = e.target.closest('div');
      parentElement.querySelectorAll('input[name="q[sub_categories_id_in][]"]').forEach((el) => {
        el.checked = e.target.checked;
      });
    });

    // タグ選択の場合、親の選択状態を設定/解除を行う
    $('input[name="q[sub_categories_id_in][]"]').click((e) => {
      const categoryId = e.target.dataset.categoryId;
      document.getElementById(`category_id_${categoryId}`).checked = false;
    });
  }
});
